import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useMutation } from '@apollo/client/react'
// components
import PositionsTree from 'components/PageComponents/Settings/Positions/components/Tree/index'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import BusinessEntityModal from 'components/Modals/BusinessEntityModal'
import { CreatePositionButton, ImportCsvButton } from 'components/CTAs'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// graphql
import { POSITIONS_SELECT_QUERY } from 'graphql/position/queries'
import {
  POSITION_CREATE_MUTATION,
  POSITION_UPDATE_MUTATION,
  POSITIONS_BULK_IMPORT_MUTATION
} from 'graphql/position/mutations'
// context
import { PositionsAPIContext } from 'containers/Positions/layers/API'
// constants
import { ENTITIES } from 'constants/entities'
// utils
import { positionProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const Positions: React.FC = () => {
  const [createMutation] = useMutation(POSITION_CREATE_MUTATION)
  const [updateMutation] = useMutation(POSITION_UPDATE_MUTATION)
  const [bulkImportMutation] = useMutation(POSITIONS_BULK_IMPORT_MUTATION)

  const { refetch, lastPosition, isLoading } = React.useContext(PositionsAPIContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Positions</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          <>
            <CreatePositionButton />
            <ImportCsvButton entity='Positions' mutation={bulkImportMutation} onImported={refetch} />
          </>
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <PositionsTree />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>

      <BusinessEntityModal
        {...positionProps}
        refetch={refetch}
        lastPosition={lastPosition}
        entityType={ENTITIES.POSITION}
        query={POSITIONS_SELECT_QUERY}
        createMutation={createMutation}
        updateMutation={updateMutation}
      />
    </>
  )
}

export default Positions
